__turbopack_context__.v({
  "actions": "not-found-module__sxuMuG__actions",
  "notFoundBody": "not-found-module__sxuMuG__notFoundBody",
  "notFoundPage": "not-found-module__sxuMuG__notFoundPage",
  "secondaryAction": "not-found-module__sxuMuG__secondaryAction",
});
